import React from 'react';
import { connect } from 'react-redux';
import GtmService from 'static/script/app/ui/google-tagmanager-service';
import { HOVER_MENUS } from './hover-menu/constants';
import HoverMenu from './hover-menu/hover-menu';
import hoverMenuStyles from './hover-menu/hover-menu.module.scss';
import { CurrencySelect } from 'components/localization/currency-select';
import { selectPreferredCurrency } from 'tradera-state/multi-currency/selectors';
import { useTranslator } from 'tradera-lang/translate';

const PlainCurrencyLink = ({
    onClick,
    onBlur,
    mouseOver,
    mouseOut,
    showMenu,
    transparentHeader,
    preferredCurrency
}) => {
    const { t } = useTranslator();
    return (
        <div
            className="position-static"
            onMouseEnter={() => mouseOver(HOVER_MENUS.CURRENCY)}
            onMouseLeave={mouseOut}>
            <button
                className={`btn-auto btn pr-1 pl-1 d-flex align-items-center ${
                    transparentHeader
                        ? 'btn-transparent-header'
                        : 'btn-link-branded'
                } ${showMenu ? 'active' : ''}`}
                tabIndex="-1"
                onClick={e => {
                    GtmService.trackAction(
                        'Top navigation',
                        'Currency menu',
                        'Open/Close'
                    );
                    onClick(e, HOVER_MENUS.CURRENCY);
                }}>
                {preferredCurrency.shortName}
            </button>
            <HoverMenu
                className={`${hoverMenuStyles.alignRight} hover-currency-menu`}
                showMenu={showMenu}>
                <div className="mt-3">
                    <CurrencySelect
                        onBlur={e => {
                            onBlur(e, HOVER_MENUS.CURRENCY);
                        }}
                        inProfileMenu={false}
                        title={t('siteHeader_currency')}
                    />
                </div>
            </HoverMenu>
        </div>
    );
};

const mapStateToProps = state => ({
    preferredCurrency: selectPreferredCurrency(state)
});

const mapDispatchToProps = {};

export const CurrencyLink = connect(
    mapStateToProps,
    mapDispatchToProps
)(PlainCurrencyLink);
